import React, { useEffect, useState } from 'react';
import '../Styles/Dashboard.css'; 
import trofeo1 from '../../../assets/trofeo1.jpg';
import deportistas1 from '../../../assets/deportistas1.jpg';
import usuarios from '../../../assets/usuarios.jpg';
import equipo from '../../../assets/equipo.jpg';
import escenarios from '../../../assets/escenarios.jpg';
import album from '../../../assets/uploadImage.jpg';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../config';
import CarouselComponent from './CarouselImagesComponent';



const Dashboard = () => {
    const navigate = useNavigate();
    const [albumImages, setAlbumImages] = useState([]);
    const fetchAlbumImages = async () => {
      try {
        const response = await fetch(`${BASE_URL}images`);
        const data = await response.json();
        setAlbumImages(data);
      } catch (error) {
        console.error('Error al obtener las imágenes:', error);
      }
    };
  
    useEffect(() => {
      fetchAlbumImages();
    }, []);
  
    const data = [
      {
        title: 'Torneos',
        image: trofeo1,
        countActive: 5,
        countInactive: 2,
        link: '/torneos',
      },
      {
        title: 'Equipos',
        image: equipo,
        countActive: 5,
        countInactive: 2,
        link: '/equipos',
      },
      {
        title: 'Usuarios',
        image: usuarios,
        countActive: 20,
        countInactive: 5,
        link: '/usuarios',
      },
      {
        title: 'Participantes',
        image: deportistas1,
        countActive: 15,
        countInactive: 3,
        link: '/participantes',
      },
      {
        title: 'Escenarios',
        image: escenarios,
        countActive: 15,
        countInactive: 3,
        link: '/escenarios',
      },
      {
        title: 'Gestion Imagenes',
        image: album,
        link: '/imagenes',
      },
    ];

    const handleCardClick = (link) => {
        navigate(link);
      };

      return (
        <div className="dash">
          <CarouselComponent images={albumImages} />
    
          <div className="dashboard-content">
            {data.map((item, index) => (
              <div key={index} className="dashboard-card" onClick={() => handleCardClick(item.link)}>
                <img src={item.image} alt={item.title} className="card-image" />
                <h2 className="card-title">{item.title}</h2>
                <p className="card-text">Activos: {item.countActive}</p>
                <p className="card-text">Inactivos: {item.countInactive}</p>
              </div>
            ))}
          </div>
        </div>
      );
    };
  

export {Dashboard};
